import IconButton from './IconButton';
import BrushOutlinedIcon from '@mui/icons-material/BrushOutlined';

const TableUpdateActionButton = ({clickHandler, idx, children}) => {
    return (
        <IconButton onClick={() => clickHandler(idx)}>
            {!children ? <BrushOutlinedIcon/> : children }
        </IconButton>
    );
};
export default TableUpdateActionButton;